import React, {useEffect} from 'react';
import styled from 'styled-components';
import {connect} from 'react-redux';
import CommentItem from './CommentItem';
import CommentForm from './CommentForm';
import * as actions from '../../store/actions';
import {AppState} from '../../store';
import Loader from '../UI/Loader/Loader';
import {IComment} from '../../Interfaces';

const HeaderWrapper = styled.div`
  background-color: black;
  color: black;
  text-align: center;
  margin: 4px;
  margin-top: 10px;
  padding: 10px;
  border: 2px solid ${({theme}) => theme.colors.main};
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.3);
  border-radius: 4px;
  background-color: ${({theme}) => theme.colors.secondary};
`;

interface HomePageProps {
  id: string;
}

type Props = HomePageProps &
  LinkStateProps &
  LinkDispatchProps;

const Comments: React.FC<Props> = ({
  id,
  comments,
  clean,
  paginateComments,
}) => {
  useEffect(() => {
    clean();
    paginateComments(id, 5);
  }, []);

  let commentList: any;

  if (comments && comments.length === 0) {
    commentList = (
      <>
        <Loader />
      </>
    );
  } else if (comments) {
    commentList = (
      <>
        {comments.map((data) => (
          <CommentItem data={data} />
        ))}
      </>
    );
  }

  return (
    <>
      {/* <CommentForm barcode={barcode} /> */}
      <HeaderWrapper>Comments</HeaderWrapper>
      {commentList}
    </>
  );
};

interface LinkStateProps {
  comments: IComment[];
}

interface LinkDispatchProps {
  paginateComments: (id: string, limit: number) => void;
  clean: () => void;
}

const mapStateToProps = ({local}: AppState) => ({
  comments: local.paginateComments.comments,
});

const mapDispatchToProps = {
  paginateComments: actions.paginateComments,
  clean: actions.cleanLocalComments,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Comments);
